const pw = "tomoko0421"

export default pw